module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="map-col">\n';
 if (maps.size > 1) { 
__p+='\n    <div id="floor-selector">\n        <label for="map-floor-selector">'+
((__t=( selectText ))==null?'':__t)+
'</label>\n        <select name="map-floor-selector" id="map-floor-selector">\n            ';
 maps.forEach(function(map) { 
__p+='\n                <option value="'+
((__t=( map.id ))==null?'':__t)+
'">'+
((__t=( map.name ))==null?'':__t)+
'</option>\n            ';
 }) 
__p+='\n        </select>\n    </div>\n';
 } 
__p+='\n';
 maps.forEach(function(map, image) { 
__p+='\n<figure id="map-'+
((__t=( map.id ))==null?'':__t)+
'" class="site-map-figure ';
 if (!map.active) { 
__p+='hide';
 } 
__p+='">\n    <img src="'+
((__t=( image ))==null?'':__t)+
'" width="'+
((__t=( map.size.width ))==null?'':__t)+
'" height="'+
((__t=( map.size.height ))==null?'':__t)+
'">\n    ';
 map.units.forEach(function(unit) { 
__p+='\n    ';
 var dot = unit.red_dot 
__p+='\n    <span class="floorplan-red-dot" style="display: block; width: '+
((__t=( dot.size * 2 ))==null?'':__t)+
'px; height: '+
((__t=( dot.size * 2 ))==null?'':__t)+
'px; margin-left: '+
((__t=( -1 * dot.size ))==null?'':__t)+
'px; margin-top: '+
((__t=( -1 * dot.size ))==null?'':__t)+
'px; position: absolute; left: '+
((__t=( dot.x / map.size.width * 100 ))==null?'':__t)+
'%; top: '+
((__t=( dot.y / map.size.height * 100 ))==null?'':__t)+
'%" ';
 if (dot.name) { 
__p+='title="'+
((__t=( dot.name ))==null?'':__t)+
'"';
 } 
__p+=' data-unit="'+
((__t=( unit.uuid ))==null?'':__t)+
'" data-floor-plan="'+
((__t=( unit.floorPlan.slug ))==null?'':__t)+
'"></span>\n    ';
 }) 
__p+='\n</figure>\n';
 }) 
__p+='\n</div>\n';
}
return __p;
};
